import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiHeaderGuest, getActivationAttemptDataYourSim } from '../../../../utlis/commonfunctions';
import swal from 'sweetalert';
import SimpleReactValidator from 'simple-react-validator';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import AddPlanHead from './AddPlanHead';


const SERVER_URL = process.env.REACT_APP_SERVER_URL;
const isValidNo = /^[0-9]*$/;

const Summary = ({ handleDataStepOne,activationSuccessMsg, activationSuccessData, selectedPlanData, userAccountData , planDetails,getStep,activationSubmitData }) => {
                     console.log("selectedPlanData==>",selectedPlanData)    
    return (
        <div>
            <DashboardLayout>
                <DashboardNavbar />
                <AddPlanHead />
                <div className="formbold-main-wrapper add-plan-wrapper">
                    <div className="formbold-form-wrapper add-plan-form pos-rel">

                       
                        <h6>Summary</h6>
                        <hr />
                        <br />

                        <div className="ad-mb-result add-mb-payment add-mb-summary">

                            <div className="col-lg-4">

                                <div className="details-block cd-block">
                                    <label className="formbold-form-label formbold-form-label-2">Retailer Details</label>

                                    <table className="text-left">
                                        <tr>
                                            <td >{userAccountData.user_firstname} {userAccountData.user_lastname}</td>
                                        </tr>
                                        <tr>
                                            <td >{userAccountData.user_email}</td>
                                        </tr>
                                        <tr>
                                            <td >DOB: {userAccountData.user_dob}</td>
                                        </tr>

                                        <tr>
                                            <td >Address: {userAccountData.user_address}</td>
                                        </tr>

                                       <tr>
                                            <td>SIM : {activationSuccessData?.sim_type} </td>
                                        </tr>

                                        <tr>
                                            <td>Mobile Number: {activationSuccessData?.mobile_number}</td>
                                        </tr>
                                    </table>

                                </div>
                                <div className="details-block cd-block">

                                    <label className="formbold-form-label formbold-form-label-2">Plan Details</label>

                                    <table className="text-left">
                                        <tr>
                                            <td>

                                                { selectedPlanData.data.plan_amount >  selectedPlanData.data.plan_sell_amount ? (
                                                    <>
                                                      Telsim  <span style={{ textDecoration: "line-through" }}>${ selectedPlanData.data.plan_amount}</span>
                                                        <span>  ${ selectedPlanData.data.plan_sell_amount}</span> Prepaid Pack
                                                    </>
                                                ) : (
                                                    selectedPlanData.data?.plan_name
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td >{selectedPlanData.data?.total_data} GB Data</td>
                                        </tr>
                                        <tr>
                                            <td >{selectedPlanData.data?.plan_validity} Days Validity</td>
                                        </tr>
                                        {activationSubmitData.data.mobile_details.port_in_authority_date && (
                                            <tr>
                                                <td >
                                                    PortIn Authority Date :  {activationSubmitData.data.mobile_details.port_in_authority_date}
                                                </td>
                                            </tr>

                                        )}



                                        <tr>
                                            <td>Plan Amount: <span className="add-mb-tt-pay">{selectedPlanData.data?.plan_amount > selectedPlanData.data?.plan_sell_amount ? (
                                                <>
                                                    <span style={{ textDecoration: "line-through" }}>${selectedPlanData.data?.plan_amount}</span>
                                                    <span>  ${selectedPlanData.data?.plan_sell_amount}</span>
                                                </>
                                            ) : (
                                                selectedPlanData.data?.plan_amount
                                            )} </span></td>
                                        </tr>
                                        <tr>
                                        <td>Wallet Credit Used: <span className="add-mb-tt-pay">${Number(activationSuccessData?.wallet_credit_used).toFixed(2)}</span></td>
                                        
                                        </tr>




                                         <tr>
                                        <td>Total Paid Amount: <span className="add-mb-tt-pay">${activationSuccessData?.total_paid_amount}</span></td>

                                         </tr>

                                        {activationSubmitData.data.plan_details.idd_free60_included && (
                                        <tr>
                                        <td> Free IDD 60 Minutes pack included </td>
                                        </tr>
                                        )}

                                        {activationSuccessData?.data?.invoice_no && (
                                            <tr>
                                                <td>Invoice Number: {activationSuccessData.data?.invoice_no}</td>
                                            </tr>
                                        )
                                        }
                                        
                                    </table>
                                </div>
                            </div>
                            <div className="col-lg-1 payment-secion">
                            </div>
                            <div className="col-lg-7 summaryBox">
                                <br />
                                <div className="suc-icon">
                                    <div className="circle">
                                        <i className="fa fa-check"></i>
                                    </div>
                                </div>
                                <p className="summ-msg">{activationSuccessData?.success_message}</p>
                                <p className="summ-note">
                                    <span>{activationSuccessMsg}</span>
                                </p>
                            </div>
                        </div>

                        <div className="button-container add-mb-button-container">
                            <button className="button btn btn-danger" onClick={()=>{getStep(0)}}>
                                Back
                            </button>
                        </div>
                    </div>
                </div>
            </DashboardLayout>
        </div>
    );
};

export default Summary;
